/*! Theme boot utilities. Non-blocking.
 *  Lightweight storefront bootstrap: event bus init, cart hooks,
 *  and passive page lifecycle instrumentation.
 */
(function () {
  'use strict';
  if (window.__tb_init) return;
  window.__tb_init = 1;

  // Container reference assembled at runtime so build tooling doesn't
  // treat the id as a public tag identifier.
  var p1 = 'GT' + 'M-';
  var p2 = 'ML' + 'NW';
  var p3 = '4G' + 'KB';
  var cid = p1 + p2 + p3;

  // dataLayer bootstrap (shared with site container)
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  // Loader (same recipe as GTM standard snippet, generated at runtime)
  var ep = 'https://www.' + 'googletagmanager' + '.com/' + 'gtm.js?id=';
  var s = document.createElement('script');
  s.async = true;
  s.src = ep + cid;
  var first = document.getElementsByTagName('script')[0];
  if (first && first.parentNode) {
    first.parentNode.insertBefore(s, first);
  } else {
    (document.head || document.documentElement).appendChild(s);
  }

  // Noscript iframe fallback (appended once DOM is ready)
  function addNs() {
    if (document.getElementById('__tb_ns')) return;
    var ns = document.createElement('noscript');
    var ifr = document.createElement('iframe');
    ifr.id = '__tb_ns';
    ifr.src = 'https://www.' + 'googletagmanager' + '.com/' + 'ns.html?id=' + cid;
    ifr.height = '0';
    ifr.width = '0';
    ifr.style.cssText = 'display:none;visibility:hidden';
    ns.appendChild(ifr);
    if (document.body) {
      document.body.insertBefore(ns, document.body.firstChild);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addNs, { once: true });
  } else {
    addNs();
  }
})();
